import { connect } from 'react-redux';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

// Lib.
import Page from '../../lib/page';

import { ALERT } from '../constants/PropTypesShapes';
import UrlResources from '../../home/constants/UrlResources';
import { renderPopUpFpti } from '../../lib/covidHelper';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import AlertContainer from './AlertContainer';

const vxTypeMapping = {
  critical: 'error',
  info: 'info',
  warning: 'warning',
};

export class Alerts extends Component {
  // Return the Dismissed Alert Cookie name by Page Wise.
  static getAlertCookie() {
    return Page.getCookie('dismissed-alerts');
  }

  // Return True, If the Cookie is already dismissed.
  static isDismissedAlert(type) {
    const dismissedAlertsCookie = Alerts.getAlertCookie();

    if (dismissedAlertsCookie && dismissedAlertsCookie[type]) {
      return true;
    }

    return false;
  }

  // Set the Current Alert as dismissed and store it in Cookie.
  static setAsDismissed(type) {
    const dismissedAlertsCookie = Alerts.getAlertCookie();
    const dismissedAlerts = dismissedAlertsCookie || {
      info: false,
      warning: false,
    };

    dismissedAlerts[type] = true;

    Page.setCookie('dismissed-alerts', JSON.stringify(dismissedAlerts), {
      path: '/',
    });
  }

  // Remove the Alert DOM after its got dismissed and stored in Cookie.
  static removeDimissedAlert(node) {
    const alertNode = ReactDOM.findDOMNode(node); // eslint-disable-line
    ReactDOM.unmountComponentAtNode(alertNode);

    // Reset class rather Remove alertNode from DOM
    if (alertNode) {
      alertNode.setAttribute('style', 'display: none');
    }
  }

  static shouldShowUpdateAlert(PageInfo) {
    let browserName = PageInfo.getBrowserName();
    let browserVersion = PageInfo.getBrowserVersion();

    browserName = browserName ? browserName.toLowerCase() : '';
    browserVersion = browserVersion ? parseInt(browserVersion, 10) : '';
    return (
      ((browserName === 'chrome' || browserName === 'firefox' || browserName === 'chrome mobile') &&
        browserVersion < 49) ||
      (browserName === 'safari' && browserVersion < 7) ||
      (browserName === 'edge' && browserVersion < 12) ||
      (browserName === 'internet explorer' && browserVersion < 11)
    );
  }

  /**
   * When link on Alert pop up is clicked
   */
  handleAlertLinkClick(e, link, messageType) {
    const href = link.getAttribute('href');
    const fptiPageId = this.getFptiPageId(messageType);
    if (!href) {
      e.preventDefault();
      trackLink({ id: `${fptiPageId}ContentClicked`, link: `smarthelp-${messageType}-alert|broken-link-clicked` });
    } else {
      const faqId = (href.split('-') && href.split('-').pop()) || '';
      trackLink({
        id: `${fptiPageId}ContentClicked`,
        link: `smarthelp-${messageType}-alert-link-clicked|${href}`,
        hpid: faqId,
      });
    }
  }

  getFptiPageId(messageType) {
    let fptiPageId = Page.isContactUsPage() ? 'contactUsAlertPopup' : renderPopUpFpti(this.props.pathname);
    // Replacing to use the existing popup alert Fpti function
    if (messageType === 'critical') {
      fptiPageId = fptiPageId.replace('AlertPopup', 'CriticalAlert');
    } else if (messageType === 'warning') {
      fptiPageId = fptiPageId.replace('AlertPopup', 'WarningAlert');
    } else if (messageType === 'info') {
      fptiPageId = fptiPageId.replace('AlertPopup', 'InfoAlert');
    }
    return fptiPageId;
  }

  // Return all `alerts` to Home Page and add only `critical` alert to other sub page.
  getAlerts() {
    let alerts = this.props.alerts;
    const { pathname } = this.props;
    const isHomePage = pathname && pathname === `/${UrlResources.HOME}`;
    const showUpdateAlert = Alerts.shouldShowUpdateAlert(Page);
    // Show only `critical` alerts if its not Home page.
    if (!isHomePage && !Page.isMachineTranslation()) {
      alerts = alerts.filter((alert) => alert && alert.messageType === 'critical');
    }
    // Hide 'update' alert if the browser version is updated.
    if (!showUpdateAlert) {
      alerts = alerts.filter((alert) => alert && (alert.messageType !== 'critical' || alert.docid !== 'CONF200'));
    }
    return alerts;
  }

  /**
   * Parsing the links in alert content
   */
  parseContent(alertContent, messageType) {
    // Adding setTimeout on top as tag element is not picked immediately safari and IE versions
    setTimeout(() => {
      if (!alertContent) {
        return;
      }

      // Link click Tracking in Article Component
      const contentLinks = alertContent.querySelectorAll('a[href]');
      Array.from(contentLinks).forEach((link) => {
        link.addEventListener('click', (e) => this.handleAlertLinkClick(e, link, messageType));
      });
    });
  }

  renderAlertMessage({ message, messageType }) {
    const alertAttribs = {
      className: 'alert-message-info',
      role: message && 'alert',
    };

    const innerHTML = Page.getHTMLElement({ message, useHTML: true });
    return message ? (
      <div
        {...alertAttribs}
        ref={(el) => {
          this.parseContent(el, messageType);
        }}
      >
        {innerHTML}
      </div>
    ) : null;
  }

  renderAlerts() {
    return this.getAlerts().map((alert) => {
      if (!alert) {
        return null;
      }
      const { messageType, message, docid } = alert;

      if (Alerts.isDismissedAlert(alert.messageType)) {
        return null;
      }

      const type = vxTypeMapping[messageType] || vxTypeMapping.info;

      const fptiPageId = this.getFptiPageId(messageType);
      trackPage({ id: fptiPageId, link: `smarthelp-${messageType}-alert` });

      // Add the Dismissable `Alert`.
      // Store the `Dismissed Alert id` in Cookie onDismiss.
      return (
        <AlertContainer
          key={docid}
          type={type}
          theme="v2"
          dismissable={messageType !== 'critical'}
          onDismiss={(alertNode) => {
            Alerts.removeDimissedAlert(alertNode);
            Alerts.setAsDismissed(messageType);
          }}
        >
          {this.renderAlertMessage({ message, messageType })}
        </AlertContainer>
      );
    });
  }

  render() {
    return <div className="alert-container">{this.renderAlerts()}</div>;
  }
}

Alerts.propTypes = {
  alerts: PropTypes.arrayOf(PropTypes.shape(ALERT)).isRequired,
  pathname: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    alerts: state.helpcenterAlerts.alerts,
    pathname: state.location.pathname,
  };
}

export default connect(mapStateToProps)(Alerts);
